import { render, staticRenderFns } from "./customizeReporting.vue?vue&type=template&id=fc922788&scoped=true"
import script from "./customizeReporting.vue?vue&type=script&lang=js"
export * from "./customizeReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc922788",
  null
  
)

export default component.exports